(function () {
  'use strict';

  var COOKIE_NAME = 'wse_club_slug';
  var COOKIE_DAYS = 90;
  var ATTR_KEY = 'club_slug';
  var SOURCE_KEY = 'attribution_source';

  function setCookie(name, value, days) {
    var expires = new Date();
    expires.setTime(expires.getTime() + days * 86400000);
    document.cookie =
      name +
      '=' +
      encodeURIComponent(value) +
      ';expires=' +
      expires.toUTCString() +
      ';path=/;SameSite=Lax';
  }

  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function detectSlugFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var ref = params.get('ref');
    if (ref) return ref.trim().toLowerCase();

    var pathMatch = window.location.pathname.match(/\/pages\/([^/?#]+)/);
    if (pathMatch) return pathMatch[1].trim().toLowerCase();

    return null;
  }

  function detectSource() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('ref')) return 'ref_param';
    if (window.location.pathname.match(/\/pages\/[^/?#]+/)) return 'club_page';
    return 'cookie';
  }

  var detected = detectSlugFromUrl();
  if (detected) {
    setCookie(COOKIE_NAME, detected, COOKIE_DAYS);
  }

  var activeSlug = getCookie(COOKIE_NAME) || detected;

  function updateCartAttributes() {
    if (!activeSlug) return Promise.resolve();

    var body = {
      attributes: {}
    };
    body.attributes[ATTR_KEY] = activeSlug;
    body.attributes[SOURCE_KEY] = detectSource();

    return fetch(window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).catch(function () {
      /* silent — attribution retried on next page load */
    });
  }

  window.WSEClub = {
    slug: activeSlug,
    refresh: function () {
      activeSlug = getCookie(COOKIE_NAME) || detectSlugFromUrl();
      this.slug = activeSlug;
      return updateCartAttributes();
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCartAttributes);
  } else {
    updateCartAttributes();
  }

  document.addEventListener('cart:refresh', updateCartAttributes);
})();
